import Vue from "vue";
import VueRouter from "vue-router";

import Index from "./components/Index"
import Boletines from "./components/Boletines"
import Experiencias from "./components/Experiencias"
import ResultadoExperiencias from "./components/Resultado_Experiencia"
import Objetivos from "./components/Objetivos"
import Imagenes from "./components/Imagenes"
import Noticias from "./components/Noticias"
import DetalleImagen from "./components/DetalleImagen"
import Reportes from "./components/Reportes"
import Mitigacion from "./components/Mitigacion"

import ExpDetail from "./components/ExpDetail"
import ExpMitigacion from "./components/MitigationDetail"


Vue.use(VueRouter);
export const router = new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/boletines",
      name: "Boletines",
      component: Boletines,
    },
    {
      path: "/mitigacion",
      name: "Mitigacion",
      component: Mitigacion,
    },
    {
      path: "/experiencias",
      name: "Experiencias",
      component: Experiencias,
    },
    {
      path: "/resultado_experiencias",
      name: "ResultadoExperiencias",
      component: ResultadoExperiencias,
    },
    {
      path: "/objetivos",
      name: "Objetivos",
      component: Objetivos,
    },
    {
      path: "/imagenes",
      name: "Imagenes",
      component: Imagenes,
    },
    {
      path: "/detalle/experiencia",
      name: "DetalleExp",
      component: ExpDetail,
    },
      {
      path: "/detalle/mitigacion",
      name: "DetalleMitigacion",
      component: ExpMitigacion,
    },
    {
      path: "/detalle/imagen",
      name: "DetalleImagen",
      component: DetalleImagen,
    },
    {
      path: "/reportes",
      name: "Reportes",
      component: Reportes,
    },
    {
      path: "/noticias",
      name: "Noticias",
      component: Noticias,
    },
  ]
});
